import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PercentageSlider } from "../../../components/percentageSlider";

const HomeSidebar = props => {
  const projects = [
    {
      icon: "node-js",
      name: "Immoforce & Internal services",
      url: "https://www.mcmakler.de"
    },
    { icon: "node-js", name: "EduTerra.pro", url: "https://eduterra.pro" },
    { icon: "node-js", name: "ProStore", url: "https://prostore.business/" },
    { icon: "node-js", name: "my.rfei.ru", url: "https://my.rfei.ru" },
    { icon: "node-js", name: "artfit.club" },
    { icon: "java", name: "savant.pro", url: "https://ru.savant.pro/" },
    { icon: "java", name: "eduarea.com", url: "http://ru.eduarea.com/" },
    { icon: "java", name: "rfei.ru", url: "https://rfei.ru" },
    { icon: "java", name: "circumflex", url: "http://circumflex.ru/" }
  ];

  const skills = [
    {
      icon: "node-js",
      name: "Node.js",
      description: "Server side JavaScript",
      percentage: 100
    },
    {
      icon: "js",
      name: "Client side JavaScript",
      description: "SPA (Angular, React.js, Vue.js), JQuery, etc.",
      percentage: 100
    },
    {
      icon: "code-branch",
      name: "VCS",
      description: "Git, Mercurial",
      percentage: 100
    },
    {
      icon: "database",
      name: "Databases",
      description: "MongoDB, PostgreSQL, ElasticSearch, redis, etc.",
      percentage: 100
    },
    {
      icon: "css3-alt",
      name: "CSS",
      description: "CSS, Less, Sass",
      percentage: 80
    },
    {
      icon: "java",
      name: "Scala, Java",
      description: "Server side usage",
      percentage: 80
    },
    {
      icon: "linux",
      name: "Linux administration",
      description: "Server setup, Docker, Nginx, etc.",
      percentage: 70
    }
  ];
  return (
    <div>
      <div className="photo">
        <img
          src={process.env.PUBLIC_URL + "/photo.jpg"}
          alt="Valerii Aligorskii"
        />
      </div>

      <h1 className="print-only">Valerii Aligorskii</h1>
      <h2 className={"subtitle profession print-only"}>
        Full Stack Web Developer
      </h2>

      <div className={"sidebar-header"}>
        <div className={"sidebar-header-icon-wrapper color-blue"}>
          <FontAwesomeIcon icon="comments" />
        </div>
        <span>Persönliche Info</span>
      </div>
      <ul className={"sidebar-list"}>
        <li>
          <div className={"sidebar-list-icon-wrapper"}>
            <FontAwesomeIcon icon="map-marker" />
          </div>
          <span>Berlin, Deutschland</span>
        </li>
        <li>
          <div className={"sidebar-list-icon-wrapper"}>
            <FontAwesomeIcon icon="phone" />
          </div>
          <a href={"tel:491747182792"}>+49 1747 1827 92</a>
        </li>
        <li>
          <div className={"sidebar-list-icon-wrapper"}>
            <FontAwesomeIcon icon="at" />
          </div>
          <a href={"mailto:stdammit@gmail.com"}>stdammit@gmail.com</a>
        </li>
        <li>
          <div className={"sidebar-list-icon-wrapper"}>
            <FontAwesomeIcon icon={["fab", "facebook-f"]} />
          </div>
          <a
            href={"https://www.facebook.com/ValeryAligorsky"}
            target="_blank"
            rel="noopener noreferrer"
          >
            ValeryAligorsky
          </a>
        </li>
        <li>
          <div className={"sidebar-list-icon-wrapper"}>
            <FontAwesomeIcon icon={["fab", "vk"]} />
          </div>
          <a
            href={"https://vk.com/stdammit"}
            target="_blank"
            rel="noopener noreferrer"
          >
            stdammit
          </a>
        </li>
      </ul>

      <div className={"sidebar-header clear-print"}>
        <div className={"sidebar-header-icon-wrapper color-green"}>
          <FontAwesomeIcon icon="laptop" />
        </div>
        <span>Projekte</span>
      </div>
      <ul className={"sidebar-list"}>
        {projects.map(p => (
          <li>
            <div className={"sidebar-list-icon-wrapper"}>
              <FontAwesomeIcon icon={["fab", p.icon]} />
            </div>
            {p.url ? (
              <a href={p.url} target="_blank" rel="noopener noreferrer">
                {p.name}
              </a>
            ) : (
              <span>{p.name}</span>
            )}
          </li>
        ))}
      </ul>

      <div className={"sidebar-header"}>
        <div className={"sidebar-header-icon-wrapper color-purple"}>
          <FontAwesomeIcon icon="pencil-alt" />
        </div>
        <span>Professional skills</span>
      </div>
      <div className="professional-skills-list sidebar-section">
        {skills.map(s => (
          <div className="professional-skills-list-item">
            <div className={"professional-skills-list-item-icon-wrapper"}>
              <FontAwesomeIcon icon={["fab", s.icon]} />
              <span>{s.name}</span>
            </div>
            <div className={"professional-skills-list-item-subtitle"}>
              {s.description}
            </div>
            <PercentageSlider percentage={s.percentage} />
          </div>
        ))}
      </div>

      <div className={"sidebar-header"}>
        <div className={"sidebar-header-icon-wrapper color-red"}>
          <FontAwesomeIcon icon="heart" />
        </div>
        <span>What I like</span>
      </div>
      <div className={"sidebar-section"}>
        <div className={"bullet-list centered"}>
          <span>Table tennis</span>
          <span>Board games</span>
          <a
            href={"https://en.wikipedia.org/wiki/Go_(game)"}
            target={"_blank"}
            rel="noopener noreferrer"
          >
            Go, Chess
          </a>
          <span>Computer Games</span>
          <span>Programming</span>
          <span>Travelling</span>
          <span>Technology</span>
          <span>Music</span>
        </div>
      </div>
    </div>
  );
};

export default HomeSidebar;
